import React from 'react';

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function syntaxHighlight(jsonText) {
  const json = escapeHtml(jsonText);
  return json.replace(/(\s*)("(?:\\u[a-fA-F0-9]{4}|\\[^u]|[^\\"])*"\s*:?)|(\btrue\b|\bfalse\b|\bnull\b)|(-?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?)/g, (match, ws, strOrKey, boolOrNull, number) => {
    if (strOrKey) {
      const isKey = /:\s*$/.test(strOrKey);
      return `${ws}<span class="json-${isKey ? 'key' : 'string'}">${strOrKey}</span>`;
    }
    if (boolOrNull) {
      const cls = /true|false/.test(boolOrNull) ? 'boolean' : 'null';
      return `<span class="json-${cls}">${boolOrNull}</span>`;
    }
    if (number) {
      return `<span class="json-number">${number}</span>`;
    }
    return match;
  });
}

export default function CodeJson({ text, style }) {
  const html = syntaxHighlight(text || '');
  return (
    <pre className="json-pre font-monospace" style={style}>
      <code dangerouslySetInnerHTML={{ __html: html }} />
    </pre>
  );
}
